export const mrpSheetFilterValStr = "styles_table_filter_obj";
